import React from "react";
import "./style.css";
import Navbar from "../../Components/Navbar";

const Privacy = () => {
  return (
    <>
      <Navbar />
      <div className="privacy-container">
        <div className="privacy-content">
          <h1 className="title">Privacy Policy</h1>

          <p>
            <strong>CouSync LLC</strong> has built{" "}
            <strong>PIA VPN Master</strong> with the primary aim of safeguarding
            your personal information and ensuring full transparency about how
            we operate. This Privacy Policy explains how we collect, use,
            disclose, and protect your information while you use our services.
          </p>

          <p>
            We are committed to user privacy. Our app does not require login or
            account creation, and users can access all VPN features without
            providing any personal information.
          </p>

          <h2>Information We Collect</h2>
          <p>
            We only collect minimal information necessary for proper app
            functionality, and we do not collect or log any personal or
            sensitive user data related to VPN usage.
          </p>

          <p>You may voluntarily provide:</p>
          <ul>
            <li>
              Name, email address, or phone number (e.g., when contacting us
              directly)
            </li>
            <li>Feedback or inquiries submitted through contact forms</li>
            <li>Confirmation of email opens (if you subscribe to updates)</li>
          </ul>
          <p>
            This information is collected only when explicitly provided by you,
            and is never sold or shared without your consent.
          </p>

          <h2>How We May Use This Information</h2>
          <ul>
            <li>To respond to user inquiries or support requests</li>
            <li>To improve app performance and resolve issues</li>
            <li>
              To send optional app-related updates or announcements (you may opt
              out at any time)
            </li>
          </ul>

          <p>
            We do not automatically collect any personal data unless explicitly
            submitted by the user.
          </p>

          <h2>VPN Service Usage</h2>
          <p>
            Our app uses Android’s VpnService API to establish a secure and
            encrypted connection between your device and our VPN servers. The
            VPN service is the core functionality of the app and is designed to:
          </p>
          <ul>
            <li>Encrypt internet traffic</li>
            <li>Protect privacy on public or unsecured networks</li>
            <li>Enable anonymous and secure browsing</li>
          </ul>

          <p>
            The VPN is only active when you manually enable it. A persistent
            system notification is displayed while the VPN is running, and you
            can disconnect it at any time.
          </p>

          <p>
            We do not monitor, log, or store any user internet activity or
            traffic data while the VPN is in use. This includes:
          </p>
          <ul>
            <li>Browsing history</li>
            <li>IP addresses</li>
            <li>DNS queries</li>
            <li>Connection timestamps</li>
          </ul>

          <p>
            All VPN traffic is securely routed through trusted servers
            exclusively to deliver the VPN service. We do not use or redirect
            traffic for ads, analytics, or monetization purposes, and we do not
            share traffic data with third parties.
          </p>

          <h2>Access to Personal Information</h2>
          <p>
            In very limited cases, we may use trusted third-party services
            (e.g., crash reporting, performance monitoring) that access minimal,
            non-personal technical data only as needed to support the app. These
            partners are contractually prohibited from using your information
            for any other purpose.
          </p>

          <h2>Permissions and Data Access</h2>
          <p>
            Our app may request the following permissions, which are used only
            for specific, user-initiated features:
          </p>
          <ul>
            <li>
              <strong>Storage:</strong> To read/write files created within the
              app
            </li>
            <li>
              <strong>Location:</strong> Only used if location-based VPN servers
              are selected
            </li>
            <li>
              <strong>SMS:</strong> To auto-read OTPs (if applicable); data is
              not stored or shared
            </li>
            <li>
              <strong>Camera/Contacts:</strong> Accessed only if required for
              optional in-app features (not used by default)
            </li>
          </ul>
          <p>
            We do not use these permissions to collect or transmit personal
            data.
          </p>

          <h2>Children’s Privacy and CSAE Policy</h2>
          <p>
            Our app is not intended for users under the age of 13. If we learn
            that a child has provided us with personal information, we delete it
            immediately.
          </p>

          <h3>Zero Tolerance Policy on CSAE:</h3>
          <ul>
            <li>Immediate removal and reporting of illegal content</li>
            <li>In-app/email reporting tools for users</li>
            <li>
              Cooperation with law enforcement and global child protection
              agencies
            </li>
          </ul>

          <p>
            For urgent reporting, contact us at:{" "}
            <strong>contact@cousync.com</strong>
          </p>

          <h2>Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy at any time to comply with
            regulations. Continued use of our services means you accept the
            latest version. Major updates will be communicated via the app or
            email (if provided).
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have any questions regarding this Privacy Policy, feel free
            to reach out: <br />
            <strong>Email: contact@cousync.com</strong>
          </p>
        </div>

        <footer className="privacy-footer">
          All rights reserved © CouSync LLC
        </footer>
      </div>
    </>
  );
};

export default Privacy;
